import type { PlatformKind } from "./ports";

export function detectPlatform(): PlatformKind {
  if (!("__TAURI_INTERNALS__" in globalThis)) return "web";
  const ua = globalThis.navigator?.userAgent ?? "";
  if (/android/i.test(ua)) return "tauri-android";
  if (/iphone|ipad|ipod/i.test(ua)) return "tauri-ios";
  return "tauri-desktop";
}
